module.exports = __webpack_public_path__ + "static/logos/icon-reddit-0df452dc245a3cc76fddb05dd846bdba.svg";